import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import truncate from "truncate";
import {Variant} from "@mui/material/styles/createTypography";

interface TruncatedTextProps {
  text: string;
  maxLength: number;
  style?: React.CSSProperties;
  className?: string;
  variant?: Variant | "inherit";
}

const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  maxLength,
  className,
  style,
  variant = "body1",
}) => {
  if (text.length <= maxLength) {
    return (
      <Typography variant={variant} className={className} style={style}>
        {text}
      </Typography>
    );
  }

  const displayText =
    text.length > maxLength ? `${truncate(text, maxLength)}` : text;

  return (
    <Tooltip title={text} placement="top">
      <Typography variant={variant} className={className} style={style}>
        {displayText}
      </Typography>
    </Tooltip>
  );
};

export default TruncatedText;
